const ERRORS = {
	REQUIRED: "This field is required.",
	LENGTH: "Use at least 8 characters",
	NUMERIC: "Should contain at least 1 numeric",
	UPPERCASE: "Should contain at least 1 uppercase",
	LOWERCASE: "Should contain at least 1 lowercase",
	SYMBOL: "Should contain at least 1 special character",
	CONFIRM_PASSWORD: "Password confirmation doesn't match.",
	FILE_SIZE: "File Size is too large (maximum 5MB)",
	MININUM_ITEM: "Field must have at least 1 items",
	START_DATE: "Start Date must be before end date",
	START_DATE_EXPIRED: "Start Date must be today or future date",
	INSUFFICIENT_BALANCE: "Insufficient balance",
	INSUFFICIENT_BALANCE_UNPAID_LEAVE: "Application cannot be processed. Please reach out to HR for assistance.",
	MINIMUM_AMOUNT: "Amount must be at least 1",
	END_DATE: "End Date must be after start date",
	HOLIDAY_DATE: "Selected date falls on a public holiday",
	LEAVE_DATE: "Selected date already has a pending or approved leave application",
	EMAIL: "Please provide a valid email",
	ANNOUNCEMENT_IMAGE_SIZE: "File dimension should at least be (400px x 400px)",
	PROFILE_IMAGE_SIZE: "File size not exceeding 5MB and image size not more than 160 pixels by 50 pixels.",
	AVATAR_FILE_TYPE: "Only JPG or PNG images are allowed.",
	AVATAR_FILE_SIZE: "File size must not exceed 5MB.",
	AVATAR_FILE_EMPTY: "Please choose a file.",
	BELOW_AGE_18: "Age must above 18.",
	SPACE: "Password should not contain spaces",
	ALPHABET_ONLY: "This field must contain only alphabetic characters",
	MOBILE_NO_MIN: "Mobile number must be at least 8 digits",
	MOBILE_NO_MAX: "Mobile number must not exceed 12 digits",
	INFO_CONFIRMED: "Please confirm the accuracy of the information.",
	ACKNOWLEDGE_POLICY: "Please confirm you understand the consequences of false information.",
	END_TIME_AFTER_START: "End Time must be after Start Time",
	OVERTIME_DATE_RANGE: "Overtime date must be within the last 1 month and before today",
	REJECT_REMARKS_REQUIRED: "Remarks are required when the reason is Others",
	INSUFFICIENT_REPLACEMENT_LEAVE: "Insufficient replacement leave balance",
};

export default ERRORS;
